<ng-container class="flexItemBiggest">
  <ac-input-container label="Group">
    <ac-select [(acModel)]="selectedGroup"
               [searchable]="true"
               (acModelChange)="getRulesOfSelectedGroup($event)"
               [items]="groupList"
               bindLabel="name"
               bindValue="id">
    </ac-select>
  </ac-input-container>

  <sortable-list [list]="ruleList"
                 [itemId]="ruleId"
                 [displayValue]="labeledValue"
                 (listOrderChanged)="onRuleListChanged($event)">
  </sortable-list>
</ng-container>
